import React, { useState } from "react"
import { navigate } from "gatsby"
import styled from "styled-components"
import Input from "../input-search/input.component"
import { AppFunctionComponent } from "../../../types"
import loupe from "../../../images/icons/loupe.svg"
import loupeWhite from "../../../images/icons/loupe-white.svg"
import { InvinsibleBackdrop } from "../language-picker/language-picker.component"
import useTranslationHook from "../../../hooks/use-translation.hook"

const StyledSearchRoot = styled.div`
  position: absolute;
  margin: 0.6em 0;
  top: 90%;
  left: 0;
  width: 100%;
  z-index: 2;
  background: #ffffff;
  border-bottom: 1px solid #dadada;
  border-left: 1px solid #dadada;
  border-right: 1px solid #dadada;
`

const StyledSearchBox = styled.form`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-bottom: 0;
  width: 100%;
  div {
    width: 100%;
  }
  svg {
    padding: 0 10px;
  }
  input {
    padding: 5px 20px 5px 40px;
  }
`

export const StyledSearchLoupe = styled.img`
  cursor: pointer;
  z-index: 1;
`

export const SearchBoxInput: AppFunctionComponent<{ label?: string }> = ({
  className,
  label,
}) => {
  const [input, setInput] = useState("")

  return (
    <StyledSearchRoot className={className}>
      <StyledSearchBox
        aria-label="Search Box"
        onSubmit={(e) => {
          e.preventDefault()
          navigate(`/search?q=${input}`, { replace: true })
        }}
      >
        <Input
          className="SearchInput"
          label={label}
          placeholder={label}
          onValueChange={(value): void => setInput(value)}
          aria-label={label}
          value={input}
        />
      </StyledSearchBox>
    </StyledSearchRoot>
  )
}

type SearchBoxType = {
  isDark?: boolean
}

const SearchBox: AppFunctionComponent<SearchBoxType> = ({
  className,
  isDark,
}) => {
  const [active, setActive] = useState(false)
  const { translate } = useTranslationHook()

  return (
    <>
      <StyledSearchLoupe
        className={className}
        src={isDark ? loupeWhite : loupe}
        onClick={() => setActive((prev) => !prev)}
      />
      {active && (
        <>
          <SearchBoxInput label={translate("Search")} />
          <InvinsibleBackdrop onClick={() => setActive(false)} />
        </>
      )}
    </>
  )
}

export default SearchBox
